import { Icon, IconColor, IconID } from '@common/Icon/Icon';
import { TooltipIcon } from '@common/TooltipIcon/TooltipIcon';
import classNames from 'classnames';

export interface SelectorBoxProps {
  selected: boolean;
  onSelect: () => void;
  objectKey: number | string;
  children?: React.ReactNode;
  dataTestId?: string;
  disabled?: boolean;
  showWarning?: boolean;
  warningText?: string;
}

export const SelectorBox = ({
  objectKey,
  onSelect,
  selected,
  children,
  dataTestId,
  disabled,
  showWarning,
  warningText,
}: SelectorBoxProps) => (
  <div
    key={objectKey}
    className={classNames(
      'text-center',
      selected ? 'border-igus-primary' : 'border-gray-200',
      disabled ? '' : 'hover:border-gray-500',
      'p-4',
      'relative',
      'border-solid',
      'border',
      disabled ? '' : 'cursor-pointer',
      'bg-white'
    )}
    onClick={() => {
      if (!disabled) {
        onSelect();
      }
    }}
    data-testid={dataTestId}
  >
    {showWarning && (
      <div className="absolute left-5 top-3" data-testid="selector-box-warning-icon">
        <TooltipIcon
          id={IconID.WARNING}
          size={10}
          tooltipContent={warningText}
          interactive={false}
          color={IconColor.ORANGE}
          primary
          iconInline
        />
      </div>
    )}
    {disabled && (
      <div
        data-testid="gray-out-box"
        className={classNames('bg-gray-300', 'z-1', 'opacity-40', 'absolute', 'w-full', 'h-full', 'left-0', 'top-0')}
      />
    )}
    {selected && (
      <div className="top-2 right-4 absolute">
        <Icon id={IconID.CHECK} color={IconColor.ORANGE} size={12} primary={false} />
      </div>
    )}
    <div className="w-3/4 relative left-1/2 transform -translate-x-1/2">{children}</div>
  </div>
);
